import { Table } from '@mantine/core'

import { Text } from '@/components/Text/Text'

import classes from './TableTitle.module.css'

export function TableTitle() {
  return (
    <Table.Thead>
      <Table.Tr className={classes.item}>
        <Table.Th>
          <Text variant="body_1">Full Name</Text>
        </Table.Th>
        <Table.Th>
          <Text variant="body_1">Action</Text>
        </Table.Th>
      </Table.Tr>
    </Table.Thead>
  )
}
